import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/Logo.png';
import termsAndConditions from '../assets/documents/247 ProCare -  Full Terms & Conditions.pdf';
import { FaInstagram, FaFacebook, FaWhatsapp, FaYoutube, FaTiktok, FaThreads, FaLinkedinIn, FaX } from 'react-icons/fa6';

function Footer() {
  return (
    <footer className="footer bg-dark-blue text-white py-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 mb-4 mb-lg-0">
            <div className="d-flex align-items-center mb-3">
              <div className="logo-container me-2">
                <div className="logo-icon footer-logo">
                  <img src={logo} alt="24/7 ProCare Logo" className="logo-img" />
                </div>
              </div>

            </div>
            <p className="text-white-50">
              Kerala's trusted healthcare staffing partner, providing reliable locum doctors 24x7.
            </p>
          </div>
          <div className="col-lg-8">
            <div className="row">
              <div className="col-md-3 mb-4 mb-md-0">
                <h5 className="mb-3">Terms & Conditions</h5>
                <ul className="list-unstyled">
                  <li><a href={termsAndConditions} target="_blank" rel="noopener noreferrer" className="text-white-50 text-decoration-none">View Terms</a></li>
                </ul>
              </div>
              <div className="col-md-3 mb-4 mb-md-0">
                <h5 className="mb-3">Quick Links</h5>
                <ul className="list-unstyled">
                  <li><Link to="/" className="text-white-50 text-decoration-none">About Us</Link></li>
                  <li><a href="#vision-mission" className="text-white-50 text-decoration-none">Vision & Mission</a></li>
                  <li><a href="#core-values" className="text-white-50 text-decoration-none">Core Values</a></li>
                  <li><a href="#contact" className="text-white-50 text-decoration-none">Contact</a></li>
                </ul>
              </div>
              <div className="col-md-3 mb-4 mb-md-0">
                <h5 className="mb-3">Services</h5>
                <ul className="list-unstyled">
                  <li><a href="#" className="text-white-50 text-decoration-none">Locum Doctor Placement</a></li>
                  <li><a href="#" className="text-white-50 text-decoration-none">Hospital Staffing</a></li>
                  <li><a href="#" className="text-white-50 text-decoration-none">Clinic Support</a></li>
                  <li><a href="#" className="text-white-50 text-decoration-none">Diagnostic Centre Staffing</a></li>
                  <li><a href="#" className="text-white-50 text-decoration-none">Non-Emergency Doctor Consultations at Home</a></li>
                  <li><a href="#" className="text-white-50 text-decoration-none">Telephone Consultations</a></li>
                  <li><a href="#" className="text-white-50 text-decoration-none">Expert Second Opinion Services</a></li>
                </ul>
              </div>
              <div className="col-md-3">
                <h5 className="mb-3">Contact Info</h5>
                <ul className="list-unstyled">
                  <li className="text-white-50">Kerala, India</li>
                  <li className="text-white-50">info@247procare.com</li>
                  <li className="text-white-50">24x7 Support</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <hr className="my-4 border-white-50" />
        <div className="row align-items-center">
          <div className="col-md-6">
            <p className="mb-0 text-white-50">© 2025 247 Procare. All rights reserved.</p>
          </div>
          <div className="col-md-6 text-end">
            <div className="social-media-links">
              <a href="https://www.instagram.com/247_procare?igsh=MW5la2NrNHZseXFpYg%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="text-white me-3" title="Instagram">
                <FaInstagram size={24} />
              </a>
              <a href="https://www.facebook.com/share/1CNTp3CMfV/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="text-white me-3" title="Facebook">
                <FaFacebook size={24} />
              </a>
                <a href="https://x.com/247procare?s=11" target="_blank" rel="noopener noreferrer" className="text-white me-3" title="X">
                  <FaX size={24} />
                </a>
              <a href="https://wa.me/message/6TVTKQQI277UJ1" target="_blank" rel="noopener noreferrer" className="text-white me-3" title="WhatsApp">
                <FaWhatsapp size={24} />
              </a>
              <a href="https://youtube.com/@247procare?si=Vn3Iill4Z-pTgYVT" target="_blank" rel="noopener noreferrer" className="text-white me-3" title="YouTube">
                <FaYoutube size={24} />
              </a>
              <a href="https://www.tiktok.com/@247_procare?_r=1&_t=ZN-93EDmosinTC" target="_blank" rel="noopener noreferrer" className="text-white me-3" title="TikTok">
                <FaTiktok size={24} />
              </a>
              <a href="https://www.threads.com/@247_procare?igshid=NTc4MTIwNjQ2YQ==" target="_blank" rel="noopener noreferrer" className="text-white me-3" title="Threads">
                <FaThreads size={24} />
              </a>
              <a href="https://www.linkedin.com/in/twenty-four-seven-pro-care-846188390?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" target="_blank" rel="noopener noreferrer" className="text-white" title="LinkedIn">
                <FaLinkedinIn size={24} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

